'use client';

import { useEffect, useState } from 'react';

/**
 * Read after mount on purpose: the pages are prerendered, so the query string
 * is only known in the browser.
 */
const useUrlQuery = (): URLSearchParams | undefined => {
  const [query, setQuery] = useState<URLSearchParams>();

  useEffect(() => {
    setQuery(new URLSearchParams(window.location.search));
  }, []);

  return query;
};

export default useUrlQuery;
